import React, { useRef } from 'react';
import clsx from 'clsx';
import TravelersRoomButton from '../TravelersRoomButton/TravelersRoomButton';
import RoomsTooltip from '../Tooltip/RoomsTooltip';
import styles from './RoomSelector.scss';
import { useIsHomePageVariantHook } from '../../hooks/useIsHomePageVariantHook';
import RoomsTooltipVariant from '../Tooltip/RoomsTooltipVariant';

const RoomsSelector = () => {
  const tooltipTriggerRef = useRef(null);
  const tooltipPopoverRef = useRef(null);
  const isVariant = useIsHomePageVariantHook();
  return (
    <div>
      <div className={clsx('position-relative width-full flex height-auto',
        !isVariant && `flex-justify-start ${styles.roomsSelectorWrapper}`)}
      >
        <TravelersRoomButton ref={tooltipTriggerRef} />
        {!isVariant
            && (
            <RoomsTooltip
              tooltipTriggerRef={tooltipTriggerRef}
              tooltipPopoverRef={tooltipPopoverRef}
            />
            )}
      </div>
      <div className="flex flex-justify-end">
        {isVariant && (
        <RoomsTooltipVariant
          tooltipTriggerRef={tooltipTriggerRef}
          tooltipPopoverRef={tooltipPopoverRef}
        />
        )}
      </div>
    </div>
  );
};

export default RoomsSelector;
